<template>
    <div class="account-page">
        <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                    <layout-header />
			<!-- /Header -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="container-fluid">
					
					<div class="row">
						<div class="col-md-8 offset-md-2">
							
							<!-- Account Content -->
							<div class="account-content">
								<div class="row align-items-center justify-content-center">
									<div class="col-md-7 col-lg-6 login-left">
										<img src="@/assets/img/login-banner.png" class="img-fluid" alt="Login Banner">	
									</div>
									<div class="col-md-12 col-lg-6 login-right">
										<div class="login-header">
											<h3>Konfirmasi Akun</h3>
										</div>
										
										<!-- Forgot Password Form -->
										
                                    <div v-if="isSuccess">
                                    <div class="alert alert-warning" v-if="msg">
                                        {{ msg }}
                                    </div>											
                                    <router-link to="/login" class="btn btn-primary btn-block btn-lg login-btn" >Login</router-link>
                                    </div>

                                                    
										
									</div>
								</div>
							</div>
							<!-- /Account Content -->
							
						</div>
					</div>

				</div>

			</div>		
			<!-- /Page Content -->
   
			<!-- Footer -->
                <layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->
    </div>
</template>

<script>  

import Util from '../../../assets/utils/utils'
import {mapGetters} from 'vuex'

import axios from 'axios';

  export default {  
    data(){
      return {
        form: {
          verification_key: '',
          password: '',
        },
        isSuccess: false,
        errors: null,
        msg: null
      }
    },
    computed: {
        ...mapGetters({ 
            isLoggedIn: 'isLoggedIn',
            user: 'user',
        }),
        currentPath() {
            return this.$route.name
        }
    },
    created:function () {
      if(this.user){
        if(this.user.hak_akses == '1')
          this.$router.push({name: 'siswa-profile-settings'})
        else if(this.user.hak_akses == '2')
          this.$router.push({name: 'instructor-profile-settings'})
        else if(this.user.hak_akses == '3')
          this.$router.push({name: 'admin-profile-settings'})
      } else {
        
        const verification_key = this.$route.query.vkey;
        this.form.verification_key = verification_key;
        this.confirmAccount();
        // console.log(idcat);
      }
        
    },
    methods: {
		
        confirmAccount: function () {
          axios.post('confirmAccount', {
                    verification_key: this.form.verification_key,
                    code: 'confAcc'
                })
                .then(res => {
                  this.isSuccess = true;
				  this.msg = res.data.message;
                })
                .catch(err => {
                    // handle error
                  console.log(err);
        			    this.errors = err.data.message;
                })
        },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Pages/ConfirmAccount/index.vue